import { Integer } from 'app/shared/domain/value-objects/integer';

export class SettingOrigin extends Integer {

}
